import { useConnect } from '@stacks/connect-react';
import { makeStandardSTXPostCondition, makeContractSTXPostCondition, FungibleConditionCode, AnchorMode } from '@stacks/transactions';
import { clientNetwork, deruptarsNFTContractAddress } from '../lib/constants';
import { isUserSignedIn, getUserData, authenticatedUserAddress } from './auth';
import { IconButton } from '@mui/material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { orange } from '@mui/material/colors';
import Badge from '@mui/material/Badge';
import HourglassTopTwoToneIcon from '@mui/icons-material/HourglassTopTwoTone';

const ftname = deruptarsNFTContractAddress.split(".")[1].split("::")[0];
const ftaddress = deruptarsNFTContractAddress.split(".")[0];

const Mint = ({ inMempool, txId, setShowConfirmModal }) => {
  const { doContractCall } = useConnect();
  const userData = isUserSignedIn() ? getUserData() : null;
  
  if (!userData) {
    throw new Error('User not signed in');
  }

  // Use the correct function call
  const userAddress = authenticatedUserAddress({ network: clientNetwork });
  console.log("p1 automagic networking: " + userAddress)

  const ftsender = userAddress;
  const postConditionAddress = ftsender;
  const postConditionCode = FungibleConditionCode.LessEqual;
  const postConditionAmount = 15000000n;

  const postConditions = makeStandardSTXPostCondition(postConditionAddress, postConditionCode, postConditionAmount);
  const contractAddress = ftaddress;
  const contractName = ftname;
  const contractSTXPostCondition = makeContractSTXPostCondition(contractAddress, contractName, postConditionCode, postConditionAmount);

  const doMint = async () => {
    const txOptions = {
      contractAddress: ftaddress,
      contractName: ftname,
      functionName: 'claim',
      functionArgs: [],
      validateWithAbi: true,
      network: clientNetwork, // Dynamic network configuration
      postConditions: [postConditions, contractSTXPostCondition],
      anchorMode: AnchorMode.Any,
      stxAddress: ftsender,
      onFinish: ({ txId }) => {
        txId(txId);
        setShowConfirmModal(true);
      }
    };
    await doContractCall(txOptions);
  }

  console.log(inMempool);
  return (
    <div>
      <IconButton id='ogMint' onClick={doMint}>
        {inMempool.state ? <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right', }} badgeContent={inMempool.total} color="warning">
          <HourglassTopTwoToneIcon sx={{ color: orange[50] }} fontSize='large' />
        </Badge> : <ControlPointIcon sx={{ color: orange[50] }} fontSize='large' />
        }
      </IconButton>
      {/* <button className='mintNFTButton' >Mint a Deruptar Now for 15 STX</button> */}
    </div>
  );
}

export default Mint;
